module.exports = __webpack_public_path__ + "img/tarjeta3.1fefd5dc.svg";